export default "__VITE_ASSET__964fdac5__"